export const getGallerySelectedIndex = state => state.gallery.selectedIndex;
